import React from 'react';
import { SizeMe } from 'react-sizeme';
import {
  Carousel,
  ElevatedContainer,
  Text,
  Link
} from '@shootsta/common-react';
import SVG from 'react-inlinesvg';
import GETTING_STARTED_STEPS from '../constants/gettingStartedSteps';
import '../styles/_getting-started-steps.scss';

const MEDIA_SIZES_SMALL = 639;

type GettingStartedStepsProps = {
  onChangeGettingStartedSteps?: any;
};

export default function GettingStartedSteps({
  onChangeGettingStartedSteps
}: GettingStartedStepsProps) {
  const onTargetInformation = (link: string) => () => {
    window.open(link, '_blank');
  };

  return (
    <ElevatedContainer className="getting-started" rounded>
      <div className="getting-started__header">
        <Text heading4 noMargin="top">
          Getting Started with Pro
        </Text>

        <Link
          className="getting-started__dismiss"
          onClick={onChangeGettingStartedSteps}
        >
          Dismiss
        </Link>
      </div>
      <SizeMe>
        {({ size }) => (
          <Carousel
            itemWidth={250}
            slidesToShow={size.width < MEDIA_SIZES_SMALL && 1}
          >
            {GETTING_STARTED_STEPS.map(
              ({ link, svgImageElement, href, stepKey }) => {
                const svgImage = (
                  <SVG
                    cacheRequests
                    src={svgImageElement}
                    uniquifyIDs
                    title={link}
                  />
                );

                return (
                  <div key={stepKey} className="getting-started__preview">
                    <div className="getting-started__item">
                      {link ? (
                        <Link onClick={onTargetInformation(href)}>
                          {svgImage}
                        </Link>
                      ) : (
                        svgImage
                      )}

                      <Text centered noMargin="bottom">
                        <Link onClick={onTargetInformation(href)}>{link}</Link>
                      </Text>
                    </div>
                  </div>
                );
              }
            )}
          </Carousel>
        )}
      </SizeMe>
    </ElevatedContainer>
  );
}
